import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	allows,
	PermissionMatrixName,
} from '@netx/core-permissions/utils/allows';
import {type IAsset} from '../schema';

export const canLockAsset = (asset?: IAsset) => {
	return (
		asset != null &&
		allows(asset.permissionMatrix, PermissionMatrixName.MODIFY) &&
		asset.readOnly !== 1 &&
		currentUserMeetsUserLevel(UserLevel.ADMIN)
	);
};
